import { render, staticRenderFns } from "./FunctionConfig.vue?vue&type=template&id=5cdb3084&scoped=true"
import script from "./FunctionConfig.vue?vue&type=script&lang=js"
export * from "./FunctionConfig.vue?vue&type=script&lang=js"
import style0 from "./FunctionConfig.vue?vue&type=style&index=0&id=5cdb3084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdb3084",
  null
  
)

export default component.exports